export default "__VITE_ASSET__15c4cbac__"